// toggleDisturbing.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Toggle Flix disturbing mechanism
 * @kind action
 * @param {object} data
 * @param {boolean} data.shouldDisturb
 * @return {Promise} Action promise.
 */
const toggleDisturbing =
  ({ shouldDisturb }) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['disturbing'],
        data: {
          shouldDisturb,
        },
      },
    });
  };

export default toggleDisturbing;
